import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import type { StudentProfileV1 } from '@/types/studentprofile';
import { PP_BASE_URL } from '@/lib/env';

type StudentsResponse = {
  data?: StudentProfileV1[];
  meta?: { total?: number };
};

export function useGetStudents(schoolYear?: string) {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  const key = baseUrl
    ? `${baseUrl}/students${schoolYear ? `?schoolYear=${encodeURIComponent(schoolYear)}` : ''}`
    : null;

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useSWR<StudentsResponse>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  const students: StudentProfileV1[] = response?.data ?? [];

  return {
    swrKey: key,
    students,
    isLoading,
    error,
    mutate,
  };
}
